import AdminTabs from "../components/AdminTabs";
import useDocumentTitle from "../../../shared/customHooks/useDocumentTitle";

const AdminPanel = () => {
  useDocumentTitle('WebUserAdmin')
  return (
    <div className="container-fluid mt-3">
      <AdminTabs />
    </div>
  );
};

export default AdminPanel;